<form
    [formGroup]="form"
    (ngSubmit)="save()"
    class="add-third-party-users-modal"
    piTesting="addThirdPartyUsersAccountModal"
>
    <div class="tapestry-title title--sm add-third-party-users-modal__header">
        {{
            'client-core.seller-experience.third-party-users.modal.title'
                | translateFormat: dialogData.accountName
        }}
        <tapestry-icon-button
            iconName="close_page"
            mat-dialog-close
            [iconTheme]="IconTheme.Light"
        ></tapestry-icon-button>
    </div>
    <div class="modal-description-text tapestry-body body--md">
        <div class="add-third-party-users-modal__body-text">
            {{ thirdPartyUserModalBodyKey | translate }}
        </div>
        <tapestry-chip-select
            formControlName="thirdPartyUsers"
            [label]="
                'client-core.seller-experience.third-party-users.modal.input'
                    | translate
            "
            [loading]="loadingThirdPartyUsers"
            [options]="thirdPartyUserOptions"
            (filterChange)="thirdPartyUserFilterChange($event)"
            required
        ></tapestry-chip-select>
        @if (
            form.controls.thirdPartyUsers.invalid &&
            (form.controls.thirdPartyUsers.dirty ||
                !form.controls.thirdPartyUsers.untouched)
        ) {
            <div class="third-party-users-validation-error">
                @if (form.controls.thirdPartyUsers.errors?.minThirdPartyUser) {
                    {{
                        'client-core.seller-tools.demo-accounts.validation.third-party-user.required'
                            | translate
                    }}
                }
            </div>
        }
    </div>
    <div class="modal-actions">
        <tapestry-button
            [text]="'text.common-terms.cancel' | translate"
            color="tertiary"
            (buttonClicked)="cancel()"
            [disabled]="saving"
            submitType="button"
            trackingName="addThirdPartyUsersCancel"
        ></tapestry-button>
        <tapestry-button
            [text]="
                'client-core.seller-experience.third-party-users.modal.save'
                    | translate
            "
            color="primary"
            [disabled]="saving || form.invalid"
            [loading]="saving"
            submitType="submit"
            trackingName="addThirdPartyUsersConfirm"
        ></tapestry-button>
    </div>
</form>
